import React from 'react'
import injectStyles from 'react-jss'

import AddIcon from '@material-ui/icons/Add'

import UserRow from './UserRow'
import { styles } from './styles'
import SubmitButton from '../../../../Components/Form/Button'

const UsersEdit = ({
  classes,
  usersHashMap,
  addUser,
  onUserChange,
  onUserDelete,
  isEditMode,
}) => {
  return (
    <div>
      {Object.entries(usersHashMap).map(([id, user], index) => {
        return (
          <UserRow
            index={index}
            key={id}
            classes={classes}
            user={{ id, ...user }}
            onDelete={onUserDelete}
            onChange={onUserChange}
            isEditMode={isEditMode}
          />
        )
      })}
      {isEditMode ? (
        <div className={classes.buttonContainer}>
          <SubmitButton
            className={classes.button}
            onClick={event => addUser(event)}
            disabled={Object.keys(usersHashMap).length >= 5}
          >
            <AddIcon />
          </SubmitButton>
          <span className={classes.buttonLabel}>Add Contact</span>
        </div>
      ) : null}
    </div>
  )
}

export default injectStyles(styles)(UsersEdit)
